<template>
    <a-config-provider :locale="zhCN">
        <div id="app" style="height: 100%;">
            <router-view></router-view>
        </div>
  </a-config-provider>
</template>
<script>
  import ConfigProvider from 'ant-design-vue/es/config-provider' // ant-design 组件 全局使用中文
  import zhCN from 'ant-design-vue/es/locale-provider/zh_CN' // ant-design 组件 全局使用中文
  import {getToken} from '@/api/token';
  export default {
      name: "App",
      data() {
          return {
              zhCN,
          };
      },
      methods:{
          _isMobile() {
              let flag = navigator.userAgent.match(
                  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
              );
              return flag;
          },
          // async login() {
          //     await this.getT();
          //     await this.jumpRouter();
          // },
          // async getT() {
          //     console.log("11111 X-Token: " + localStorage.getItem('X-Token'))
          //     localStorage.removeItem('X-Token')
          //     var params={
          //         timeStamp:30000
          //     }
          //     await getToken(params).then((res)=>{
          //         console.log("22222 res.data: " + res.data)
          //         localStorage.setItem('X-Token', res.data);
          //     })
          // },
          // jumpRouter() {
          //     console.log("33333 X-Token: " + localStorage.getItem('X-Token'))
          //     this.$router.replace("/index");
          // }
      },
      mounted() {
          if (this._isMobile()) {

              //跳转到你手机路由
              this.$router.replace("/phoneIndex");
              // 页面开始加载时修改font-size
            //   var html = document.getElementsByTagName("html")[0];
            //   var oWidth = document.body.clientWidth || document.documentElement.clientWidth;
            //   // 这里的750是指设计图的大小,自己根据实际情况改变
            //   alert(oWidth / 750 * 200)
            //   html.style.fontSize = oWidth / 750 * 200 + "px";
            //   console.log('rem:', html.style.fontSize);
          } else {

              //跳转到PC端路由
              // this.login();
              // this.getT();
              // setInterval(this.getT,30000);
              // // debugger
              // if(!localStorage.getItem('X-Token')) {
              //     this.$router.replace("/index");
              // }
              this.$router.replace("/index");
          }
      }
  };
</script>
<style scoped lang="less">
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

#app::-webkit-scrollbar{
    display: none;
}
*{
  margin: 0;
  padding: 0;
}
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
